module.exports = __webpack_public_path__ + "img/service_backend_4_mob_2x.b070ef24.jpg";